import { defineChain } from 'viem';

export const galactica = defineChain({
  id: 613419,
  name: 'Galactica',
  nativeCurrency: {
    decimals: 18,
    name: 'GNET',
    symbol: 'GNET',
  },
  rpcUrls: {
    default: {
      http: ['https://galactica-mainnet.g.alchemy.com/public'],
      webSocket: ['wss://galactica-mainnet.g.alchemy.com/public'],
    },
  },
  blockExplorers: {
    default: {
      name: 'Galactica Explorer',
      url: 'https://explorer.galactica.com',
    },
  },
  contracts: {
    multicall3: {
      address: '0xcA11bde05977b3631167028862bE2a173976CA11',
    },
  },
});

export const galacticaCassiopeia = defineChain({
  id: 843843,
  name: 'Galactica Cassiopeia',
  nativeCurrency: {
    decimals: 18,
    name: 'GNET',
    symbol: 'GNET',
  },
  rpcUrls: {
    default: {
      http: ['https://galactica-cassiopeia.g.alchemy.com/public'],
      webSocket: ['wss://galactica-cassiopeia.g.alchemy.com/public'],
    },
  },
  blockExplorers: {
    default: {
      name: 'Galactica Cassiopeia Explorer',
      url: 'https://galactica-cassiopeia.explorer.alchemy.com',
    },
  },
  contracts: {
    multicall3: {
      address: '0xcA11bde05977b3631167028862bE2a173976CA11',
    },
  },
  testnet: true,
});
